import * as React from "react";
import { Checkbox } from "@progress/kendo-react-inputs";

import { Button } from "components/Button/Button";
import { Dialog } from "components/Dialog/Dialog";
import { DialogActionsBar } from "components/Dialog/DialogActionsBar";

import type { CheckboxChangeEvent } from "@progress/kendo-react-inputs";

const PREVENT_WARNING = "Don't show this warning again";

interface NavigateExternalProps {
  saveUserPreference: (preference: string, value: any) => void;
  hideExternalLinkWarning: object;
}
interface NavigateExternalState {
  showExternalLinkDialog: boolean;
  clickedLink: string;
  preventWarning: boolean;
}

const LEFT_CLICK = 0;
const MIDDLE_CLICK = 1;

export default class NavigateExternal extends React.PureComponent<
  NavigateExternalProps,
  NavigateExternalState
> {
  dialogContainerRef = React.createRef<HTMLDivElement>();

  constructor(props: NavigateExternalProps) {
    super(props);

    this.state = {
      showExternalLinkDialog: false,
      clickedLink: "",
      preventWarning: false,
    };

    this.toggleWarning = this.toggleWarning.bind(this);
  }

  handleCancelClick = () => {
    this.setState({
      showExternalLinkDialog: false,
    });
  };

  handleConfirmClick = () => {
    window.open(this.state.clickedLink);
    this.setState({
      showExternalLinkDialog: false,
    });
  };

  onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.button === LEFT_CLICK || e.button === MIDDLE_CLICK) {
      const targetLink = e.target as HTMLAnchorElement;
      const targetURL = targetLink.href ? new URL(targetLink.href) : "";
      const targetDomain = targetURL ? targetURL.hostname : "";
      const shouldIgnore = targetLink.getAttribute("data-ignore-domain") === "true";
      if (targetLink.tagName.toUpperCase() === "A" && !shouldIgnore) {
        if (!targetURL && !targetDomain) {
          return;
        }

        if (
          targetDomain !== window.location.hostname &&
          targetLink.href !== "javascript:void(0)" &&
          !targetLink.download
        ) {
          e.preventDefault(); // stop initial follow
          if (!this.props.hideExternalLinkWarning) {
            this.setState({
              showExternalLinkDialog: true,
              clickedLink: targetLink.href,
            });
          } else {
            window.open(`${process.env.PUBLIC_URL}${targetLink.href}`);
          }
        }
      }
    }
  };

  render() {
    return (
      <div className="navigate-external" onMouseDown={this.onClick} ref={this.dialogContainerRef}>
        {this.props.children}
        {this.state.showExternalLinkDialog && (
          <Dialog
            appendTo={this.dialogContainerRef.current}
            title="Warning!"
            onClose={this.handleCancelClick}
          >
            <p>
              The link you clicked is taking you to another site. Are you sure you wish to continue?
            </p>
            <p>
              <i>{this.state.clickedLink}</i>
            </p>
            <Checkbox
              checked={this.state.preventWarning}
              disabled={false}
              id="prevent-warning"
              label={PREVENT_WARNING}
              labelPlacement="after"
              onChange={this.toggleWarning}
            />
            <DialogActionsBar>
              <Button onClick={this.handleCancelClick}>Cancel</Button>
              <Button themeColor="primary" onClick={this.handleConfirmClick}>
                Continue
              </Button>
            </DialogActionsBar>
          </Dialog>
        )}
      </div>
    );
  }

  toggleWarning(e: CheckboxChangeEvent) {
    this.setState((prevState) => ({ preventWarning: !prevState.preventWarning }));
    this.props.saveUserPreference("HideExternalLinkWarning", e.value);
  }
}
